'use client';

import { NetworkAvatar } from './legacy/network-avatar';
import NetworkName from './NetworkName';

interface Props {
  symbol?: string;
}
export default function Network({ symbol, ...props }: Props) {
  return (
    <div className="flex items-center">
      <NetworkAvatar symbol={symbol} className="w-5 h-5 mr-1.5" />
      <NetworkName symbol={symbol} />
    </div>
  );
}
